const AutoSaveEvent = {
  REQUESTED: "requested",
  PROCESSED: "processed",
};

export default AutoSaveEvent;
